import './restore-key-status.scss';
import { KeyRecoveryStatus } from 'constants/key-recovery';
import { useMemo } from 'react';
import cn from 'classnames';

interface IRestoreKeyStatus {
  status: KeyRecoveryStatus;
}

export default function RestoreKeyStatus({ status }: IRestoreKeyStatus) {
  const [statusText, statusClass] = useMemo(() => {
    switch (status) {
      case KeyRecoveryStatus.SIGNED:
        return ['Восстановлен', 'restore-key-status_green'];
      default:
        return ['Подписание', 'restore-key-status_yellow'];
    }
  }, [status]);
  return (
    <div className={cn('restore-key-status', statusClass)}>{statusText}</div>
  );
}
